<template>
  <div>
    <div class="payment-card mx-auto" v-if="!error && remain != 0">
      <p class="center ml-10 mr-10">
        <button class="button" id="btPrint" @click="createPDF()">
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <v-icon color="white" large>mdi-printer</v-icon>&nbsp;&nbsp;Click
            พิมพ์ใบชำระเงิน&nbsp;</span
          >
        </button>
      </p>
    </div>
    <v-card class="payment-card mx-auto" :loading="loading" :disabled="loading">
      <div v-if="error" class="text-center">
        <h3 class="red--text">
          <v-icon color="red">mdi-alert-circle</v-icon>
          {{
            typeof error === "object"
              ? objectTranslatorLowerCase(error, "message")
              : error
          }}
        </h3>
        <h4 class="mt-3">
          โปรดติดต่อเจ้าหน้าที่สำนักทะเบียนและบริการการศึกษา
          ตามข้อมูลติดต่อด้านล่าง
        </h4>
      </div>

      <div v-else-if="remain == 0 && !loading" class="text-center">
        <h3 class="red--text">
          <v-icon color="red">mdi-alert-circle</v-icon>
          ไม่พบยอดค้างชำระของรหัสนักศึกษา {{ student_id }} ในปีการศึกษา
          {{ semester }}/{{ year }}
        </h3>
      </div>

      <div v-show="!error && remain != 0">
        <div id="tab">
          <table class="center">
            <tr>
              <td width="14%" rowspan="2" align="center">
                <img src="black_logo.png" width="90%" />
              </td>
              <td colspan="3" valign="bottom">
                <strong
                  >สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง
                  <span class="english-text">
                    | King Mongkut's Institute of Technology Ladkrabang</span
                  ></strong
                >
              </td>
            </tr>
            <tr>
              <td colspan="3" valign="top">
                สำนักทะเบียนและบริการการศึกษา
                <span class="english-text">
                  | KMITL Registration and Educational Service Office</span
                >
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <strong
                  >ใบแจ้งการชำระเงินค่าธรรมเนียมการศึกษา ระดับ{{ level_name_th
                  }}<br />

                  Pay in slip for tuition fee &nbsp;({{
                    level_name_en
                  }})</strong
                >
              </td>
              <td colspan="1" align="right">
                วันที่&nbsp;&nbsp;{{ date_now_thai }}<br /><span
                  class="english-text"
                  >Date&nbsp;&nbsp;{{ date_now_english }}</span
                >
              </td>
            </tr>

            <tr>
              <td colspan="1" align="left">
                ภาคการศึกษาที่ &nbsp;{{ semester }} <br />
                <span class="english-text">Semester</span>
              </td>
              <td colspan="1" align="left">
                ปีการศึกษา &nbsp;&nbsp;&nbsp;&nbsp;{{ year }}
                <br />
                <span class="english-text">Academic Year</span>
              </td>
              <td colspan="2" align="left">
                รหัสประจำตัว &nbsp;{{ student_id }} <br />
                <span class="english-text">Student ID</span>
              </td>
            </tr>

            <tr>
              <td colspan="2" align="left">
                ชื่อ – สกุล&nbsp; &nbsp;&nbsp;{{
                  UserInfo_nameTh + " " + UserInfo_surnameTh
                }}
                <br />
                <span class="english-text">Name-Surname</span>&nbsp;&nbsp;{{
                  UserInfo_nameEn + " " + UserInfo_surnameEn
                }}
              </td>
              <td align="left" colspan="2">
                คณะ / วิทยาลัย&nbsp;&nbsp;&nbsp;&nbsp;{{ faculty_name_th }}
                <br /><span class="english-text"
                  >Faculty/ School/ College &nbsp;&nbsp;&nbsp;&nbsp;{{
                    faculty_name_en
                  }}</span
                >
              </td>
            </tr>

            <tr>
              <td align="left" colspan="4">
                สาขาวิชา&nbsp;&nbsp;{{ curriculum_name_th }} <br />
                <span class="english-text"
                  >Curriculum &nbsp;&nbsp;{{ curriculum_name_en }}</span
                >
              </td>

              <!-- <td
                class="mini-font-left"
                align="left"
                colspan="1"
                v-if="branch_name_th || study_plan_name_th"
              >
                <span v-if="branch_name_th" class="english-text"
                  >แขนง&nbsp;{{ branch_name_th }} <br />
                  (branch&nbsp;{{ branch_name_en }})<br
                /></span>
                <span v-if="study_plan_name_th" class="english-text"
                  >แผนการศึกษา&nbsp;{{ study_plan_name_th }}&nbsp;({{
                    study_plan_name_en
                  }})</span
                >
              </td> -->
            </tr>
            <tr>
              <td height="5"></td>
            </tr>
          </table>

          <!-- ตารางค่าจ่าย -->
          <table class="center cell">
            <tr>
              <td width="7%">ลำดับ<br />No.</td>
              <td width="53%">รายการ<br />Description</td>
              <td width="10%">จำนวน<br />Quantity</td>
              <td width="15%">หน่วยละ<br />Unit price</td>
              <td width="15%">จำนวนเงิน<br />Amount (baht)</td>
            </tr>

            <tr v-for="(item, index) in list_transaction" :key="index">
              <td>{{ index + 1 }}</td>
              <td align="left" v-html="item.description"></td>
              <td align="center" v-html="item.quantity"></td>
              <td align="right" v-html="format_amount(item.unit)"></td>
              <td align="right" v-html="format_amount(item.amount)"></td>
            </tr>
          </table>

          <table
            class="center cell-total"
            border-top="none"
            style="background-color: #f5f5f5"
          >
            <tr>
              <td width="20%" align="left">
                ยอดชำระเป็นตัวอักษร <br />
                <span class="english-text">Net paid (in words)</span>
              </td>
              <td width="65%" align="left">
                {{ tuitionPayText }}-- <br />{{ tuitionPayText_english }}
              </td>
              <td width="15%" align="right">
                {{ remain_add_comma_and_stang }}
              </td>
            </tr>

            <tr>
              <td colspan="3" class="notice-box1">
                ชำระภายในวันที่&nbsp;<b
                  >{{ end_tuition_pay_date_text }}&nbsp;ก่อนเวลา 23:00 น.</b
                >&nbsp;
                <span v-if="show_text_no_charge"
                  >โดยไม่มีค่าปรับชำระเงินล่าช้า</span
                >
                <br />
                The payment must be made within&nbsp;<b
                  >{{ end_tuition_pay_date_text_en }}&nbsp;before 11:00 PM</b
                >
                &nbsp;
                <span v-if="show_text_no_charge"
                  >without late payment penalty charge</span
                >
              </td>
            </tr>
          </table>

          <table class="center cell-total" border-top="none">
            <tr>
              <td class="mini-font-left" width="75%">
                <b><u>หมายเหตุ (Remark)</u></b>
                <div class="tab1">
                  <div>
                    1. ชำระเต็มจำนวนโดยไม่มีค่าปรับชำระเงินล่าช้าภายในวันที่
                    {{ end_datetime_no_charge }} หลังจากนั้นมีค่าปรับวันละ 50
                    บาทสำหรับปริญญาตรี และวันละ 100 บาทสำหรับบัณฑิตศึกษา
                    โดยต้องชำระเต็มจำนวนพร้อมค่าปรับ (ถ้ามี)
                    ให้แล้วเสร็จภายในวันที่
                    {{ last_datetime_pay_date_of_academic }}
                    <span class="english-text">
                      (Full payment without late payment penalty charge by
                      {{ end_datetime_no_charge_en }}. After that, there is a
                      daily penalty charge of 50 baht for undergraduate students
                      and 100 baht for graduate students. The full amount must
                      be paid including penalty charges (if any) and must be
                      completed by {{ last_datetime_pay_date_of_academic_en }}.)
                    </span>
                  </div>
                  <div>
                    2. หากนักศึกษาไม่ชำระเงินให้ครบถ้วนภายในวันที่
                    {{ last_datetime_pay_date_of_academic }}
                    นักศึกษาจะต้องยื่นคำร้องขอลาพักการศึกษา
                    <span class="english-text">
                      (Failure to pay tuition fees by
                      {{ last_datetime_pay_date_of_academic_en }}, the student
                      must apply for a leave of absence.)
                    </span>
                  </div>
                  <div>
                    3. ผู้ชำระเงินเป็นผู้รับผิดชอบค่าธรรมเนียมธนาคารในอัตรา 10
                    บาท
                    <span class="english-text">
                      (The net paid amount does not include 10 baht of bank
                      charge.)
                    </span>
                  </div>
                  <div class="bigger-mini-font-right">
                    <i
                      ><font color="red"
                        >* โปรดตรวจสอบข้อมูลเพิ่มเติมจากปฏิทินการศึกษา (Please
                        check the academic calendar for more information.)</font
                      ></i
                    >
                  </div>
                </div>
              </td>
              <td class="mini-font-left" width="25%">
                สำหรับเจ้าหน้าที่ธนาคาร<br />
                <span class="english-text">&nbsp;(For bank officer)</span>
                <br /><br /><br />ผู้รับเงิน..........................................<span
                  class="english-text"
                  ><br />&nbsp;(Cashier)</span
                >
                <br />วันที่................................................
                <span class="english-text"> <br />&nbsp;(Date)</span>
              </td>
            </tr>
          </table>

          <div class="seperate-page">
            <br /><br />*** โปรดเก็บในรายการนี้ไว้ เพื่อเป็นหลักฐานการชำระเงิน
            (สำหรับนักศึกษา / For student) *** <br />
            ---------------------------------------------------------------------------------------------------------
            <br />*** ส่วนของธนาคาร กรุณาเก็บค่าธรรมเนียมจากผู้ชำระเงิน
            (สำหรับธนาคาร / For bank) ***
          </div>

          <table class="center">
            <tr>
              <td width="15%" align="center">
                <img src="black_logo.png" width="90%" />
              </td>
              <td width="60%" align="left">
                <strong
                  >สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง <br />
                  <span class="english-text"
                    >King Mongkut's Institute of Technology Ladkrabang</span
                  ></strong
                >
              </td>
              <td width="25%" align="right">
                <div class="bigger-mini-font-left">
                  วันที่&nbsp;&nbsp;{{ date_now_thai }}<br /><span
                    class="english-text"
                    >Date&nbsp;&nbsp;{{ date_now_english }}</span
                  >
                  <br />สาขา
                  <span class="english-text">(ฺBranch)</span
                  >.......................................
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <strong
                  >ใบแจ้งการชำระเงินค่าธรรมเนียมการศึกษา ระดับ{{
                    level_name_th
                  }}&nbsp;/ Pay in slip for tuition fee &nbsp;({{
                    level_name_en
                  }})</strong
                >
              </td>
            </tr>
          </table>

          <table class="center cell-total">
            <tr class="mini-font-left">
              <td width="70%" rowspan="2">
                <!-- ตารางจำนวนเงิน -->
                <table class="center sub-table">
                  <tr class="mini-font">
                    <td width="70%">
                      จำนวนเงินเป็นตัวอักษร /
                      <span class="english-text">Net paid (in words)</span>
                    </td>
                    <td>จำนวน / <span class="english-text">Amount</span></td>
                  </tr>
                  <tr>
                    <td class="mini-font-left">
                      {{ tuitionPayText }}-- <br />
                      <span class="english-text">{{
                        tuitionPayText_english
                      }}</span>
                    </td>
                    <td class="mini-font">
                      {{ this.remain_add_comma_and_stang }}- บาท
                    </td>
                  </tr>
                </table>

                <!-- <span class="bigger-mini-font-left pl-7">
                  &nbsp;{{ barcode_value }}</span><br /> -->
                <div class="notice-box1">
                  ชำระภายในวันที่&nbsp;<b>{{ end_tuition_pay_date_text }}&nbsp;ก่อนเวลา 23:00 น.</b
                  >&nbsp;
                  <span v-if="show_text_no_charge"
                    >โดยไม่มีค่าปรับชำระเงินล่าช้า</span
                  >
                  <br />
                  The payment must be made within&nbsp;<b>{{
                    end_tuition_pay_date_text_en
                  }}&nbsp;before 11:00 PM</b
                  >&nbsp;
                  <span v-if="show_text_no_charge"
                    >without late payment penalty charge</span
                  >
                </div>

                <!-- Bank logo -->
                <table class="center sub-table-no-border td" font>
                  <tr>
                    <td width="55%" valign="middel">
                      <img
                        src="ktb.jpg"
                        width="35%"
                        valign="middle"
                      />
                      <br />
                      {{ bank_name_th }}<br /><span class="english-text">
                        {{ bank_name_en }}</span
                      >
                    </td>
                    <td width="45%" align="center">
                      <qrcode-vue
                        :value="qrValue"
                        :size="80"
                        :render-as="renderAs"
                      ></qrcode-vue>
                      <font style="font-weight: bold">Pay with QR code</font>
                    </td>
                  </tr>
                  <tr class="mini-font">
                    <td colspan="2">
                      <img
                        ref="my_barcode"
                        style="width: 80%; margin-bottom: -15px"
                      /><br />
                      <font style="font-weight: bold">Pay with Barcode</font>
                    </td>
                  </tr>
                </table>
              </td>
              <td>Company Code : {{ company_code }}</td>
            </tr>

            <tr class="mini-font-left">
              <td>
                ชื่อ (Name) : {{ UserInfo_nameTh }}
                <br />
                นามสกุล (Surname) : {{ UserInfo_surnameTh }} <br /><b
                  >เลขที่อ้างอิง (Ref1) : {{ ref_1 }} <br />เลขที่อ้างอิง (Ref2)
                  : {{ ref_2 }}</b
                ><br />
                <span class="english-text">
                  โทรศัพท์ (Tel) : ......................................
                </span>
                <br /><br />

                <table class="center sub-table">
                  <tr>
                    <td>
                      สำหรับเจ้าหน้าที่ธนาคาร
                      <span class="english-text">&nbsp;(For bank officer)</span>
                      <br />ผู้รับเงิน..........................................<span
                        class="english-text"
                        ><br />&nbsp;(Cashier)</span
                      >
                      <br />วันที่................................................
                      <span class="english-text"> <br />&nbsp;(Date)</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import centralProvider from "@/services/central.provider";
import payInSlipProvider from "@/services/pay_in_slip.provider";
import { objectTranslatorLowerCase } from "@/helper/translator";
import JsBarcode from "jsbarcode";
import QrcodeVue from "qrcode.vue";
const centralService = new centralProvider();
const payInSlipService = new payInSlipProvider();
export default {
  name: "payment_slip",
  // props: ["student_id"],
  data: () => ({
    loading: null,
    error: null,
    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    UserInfo_nameEn: null,
    UserInfo_surnameEn: null,
    year: null,
    semester: null,
    student_id: null,
    level: null,
    sub_level_id: null,
    as_student: false,
    list_transaction: [],
    ref_1: null,
    ref_2: null,
    end_tuition_pay_date_text: null,
    end_tuition_pay_date_text_en: null,
    end_datetime_no_charge: null,
    end_datetime_no_charge_en: null,
    last_datetime_pay_date_of_academic: null,
    last_datetime_pay_date_of_academic_en: null,
    show_text_no_charge: false,

    level_name_th: null,
    level_name_en: null,
    study_plan_name_th: null,
    study_plan_name_en: null,
    faculty_name_th: null,
    faculty_name_en: null,
    curriculum_name_th: null,
    curriculum_name_en: null,
    branch_name_th: null,
    branch_name_en: null,
    remain_add_comma_and_stang: null,
    date_now_english: null,
    date_now_thai: null,
    tuitionPayText: null,
    tuitionPayText_english: null,
    bank_name_th: null,
    bank_name_en: null,
    barcode_value: null,
    qrValue: "",
    renderAs: "svg",
    remain: 0,
    company_code: null,

    a: [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ],
    b: [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ],
  }),
  components: { QrcodeVue },
  methods: {
    objectTranslatorLowerCase,
    async fetch_data() {
      this.loading = true;
      this.year = this.$route.query.year;
      this.semester = this.$route.query.semester;
      this.student_id = this.$route.query.student_id;
      this.level = this.$route.query.level_id;
      this.sub_level_id = this.$route.query.sub_level_id;
      this.as_student = this.$route.query.as_student === "1";

      //-------------------------- Get time from server ----------------------------------------
      const serverTime = await centralService.getServertime();
      const milliseconds = serverTime.timestamp * 1000;
      // const dateObject = new Date(milliseconds);
      // const date_year = dateObject.toLocaleString("th-TH", { year: "numeric" }); // 2019
      // Change to year that applicant entrances

      //-------------------------- Get payment info ---------------------------------------------
      let dataTuitionFee;
      try {
        dataTuitionFee = await payInSlipService.getPaymentTuitionFee(
          this.level,
          this.year,
          this.semester,
          this.student_id,
          this.sub_level_id,
          this.as_student
        );
        if (
          this.as_student &&
          this.$store.state.user.is_authorized_officer &&
          dataTuitionFee.payment_condition_mode !== "student"
        ) {
          this.error = this.$t("payment.student_mode_unavailable");
          this.loading = false;
          return;
        }
      } catch (error) {
        this.error =
          error.response?.data?.message ||
          error.message ||
          this.$t("payment.load_error");
        this.loading = false;
        return;
      }

      this.UserInfo_nameTh = dataTuitionFee.prename_th + dataTuitionFee.name_th;
      this.UserInfo_surnameTh = dataTuitionFee.surname_th;
      this.UserInfo_nameEn =
        dataTuitionFee.prename_en + " " + dataTuitionFee.name_en;
      this.UserInfo_surnameEn = dataTuitionFee.surname_en;
      //---------------------------- Assertion last pay date -------------------------------------

      let date = new Date(dataTuitionFee.end_tuition_pay_date);
      this.end_tuition_pay_date_text = date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      this.end_tuition_pay_date_text_en = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      date = new Date(dataTuitionFee.end_datetime_no_charge);
      this.end_datetime_no_charge = date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      this.end_datetime_no_charge_en = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      date = new Date(dataTuitionFee.last_datetime_pay_date_of_academic);
      this.last_datetime_pay_date_of_academic = date.toLocaleDateString(
        "th-TH",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      );
      this.last_datetime_pay_date_of_academic_en = date.toLocaleDateString(
        "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      );
      this.show_text_no_charge = dataTuitionFee.show_text_no_charge;
      this.faculty_name_th = dataTuitionFee.faculty_name_th;
      this.faculty_name_en = dataTuitionFee.faculty_name_en;
      this.curriculum_name_th = dataTuitionFee.curriculum_short_name_th;
      this.curriculum_name_en = dataTuitionFee.curriculum_short_name_en;
      this.level_name_th = dataTuitionFee.level_name_th;
      this.level_name_en = dataTuitionFee.level_name_en;
      if (this.sub_level_id) {
        this.curriculum_name_th = dataTuitionFee.curriculum_short_name_th_4_1;
        this.curriculum_name_en = dataTuitionFee.curriculum_short_name_en_4_1;
        this.level_name_th = this.level_name_th + " (โครงการแววนวัตกร)";
        this.level_name_en = this.level_name_en + " (Future Innovation)";
      }
      if (this.level > 1) {
        this.study_plan_name_th = dataTuitionFee.study_plan_name_th;
        this.study_plan_name_en = dataTuitionFee.study_plan_name_en;
      }

      this.list_transaction = dataTuitionFee.list_transaction;
      this.remain = dataTuitionFee.remain;
      if (this.remain != 0) {
        this.remain_add_comma_and_stang = this.currency_converter(this.remain);
        // Date In B.E. for example 29 เมษายน 2564
        let date = new Date(milliseconds);
        let date_now_thai1 = date.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        this.date_now_thai = date_now_thai1;
        let date_now_en = date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        this.date_now_english = date_now_en;
        let remain1 = dataTuitionFee.remain;
        this.tuitionPayText = this.getBahtText(remain1);
        this.tuitionPayText_english = this.withDecimal(remain1);
        this.company_code = dataTuitionFee.company_code;
        this.bank_name_th = dataTuitionFee.bank_name_th;
        this.bank_name_en = dataTuitionFee.bank_name_en;
        this.ref_1 = dataTuitionFee.ref_1;
        this.ref_2 = dataTuitionFee.ref_2;
        this.barcode_value = dataTuitionFee.barcode_value;

        JsBarcode(this.$refs.my_barcode, this.barcode_value, {
          text: " ",
          // height: 45,
        });
        // ============ Qrcode ====================
        this.qrValue = this.barcode_value;
      }
      this.loading = false;
    },

    format_amount(htmlAmount) {
      if (!htmlAmount) return htmlAmount;
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlAmount, "text/html");
      const fontEl = doc.querySelector("font");
      if (!fontEl) return htmlAmount;
      const color = fontEl.getAttribute("color") || "black";
      const value = parseFloat(fontEl.textContent);
      return `<font color = ${color}>${this.currency_converter(value)}</font>`;
    },

    currency_converter(value) {
      // let data = Math.abs(value.toFixed(2)).toLocaleString("en-US");
      let data = null;
      if (value == 0) {
        data = "0.00";
      } else {
        data = Math.abs(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return data;
    },

    createPDF() {
      let sTable = document.getElementById("tab").innerHTML;

      let style = "<style>";
      style =
        style +
        "@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');";
      style = style + "body{font-family: 'Sarabun', sans-serif;}";
      style = style + "ul {list-style-type: none; padding: 0;}";
      style = style + "li {display: inline-block; margin: 0 10px;}";
      style = style + "a {color: #42b983;}";
      style = style + "u {text-decoration: underline;}";
      style =
        style + "span1 {border-bottom:solid black 1px; padding-right:10rem;}";
      style = style + "table {width:100%;}";
      style =
        style +
        "table, th, td, tr {table-layout: fixed; overflow: hidden; padding: 2px 3px;}";
      style =
        style +
        "table.center {width:100%; margin-left : auto; margin-right : auto; font-size: 11px;}";
      style =
        style +
        ".cell {vertical-align : middle; text-align : center; width : 100%; border-collapse: collapse;";
      style =
        style + "border-top: double; border-top-width: 4px; font-size:11px;}";
      style =
        style + ".cell th {border:1px solid #C0C0C0; background:#F0F0F0;}";
      style =
        style +
        ".cell td {border:1px solid #C0C0C0; vertical-align:top; padding: 2px 4px;}";
      style =
        style +
        ".cell-total {vertical-align:middle; text-align:center; width:100%; ";
      style = style + "border-collapse:collapse; font-size:11px;}";
      style =
        style +
        ".cell-total th {border:1px solid #C0C0C0; background:#F0F0F0; font-size: 11px;}";
      style =
        style +
        ".cell-total td {border:1px solid #C0C0C0; vertical-align: top; ";
      style = style + "padding: 2px 4px; font-size: 11px;}";
      style =
        style +
        ".notice-box {font-size: 9px; vertical-align:middle; text-align:left; padding: 10px 10px 10px 10px; outline-style: solid; outline-color: silver; ";
      style = style + "outline-width: 1px; outline-offset: -10px; }";
      style =
        style +
        ".notice-box1 {text-align: center; color: red; font-size: 9px;}";
      style = style + ".tab1 {padding-left: 2em;}";
      style = style + ".mini-font-right {font-size: 11px; text-align: right;}";
      style = style + ".mini-font-left {font-size: 9px; text-align: left;}";
      style = style + ".mini-font {font-size: 11px; text-align: center;}";
      style = style + ".seperate-page {font-size: 8px; text-align: center;}";
      style =
        style + ".bigger-mini-font-right {font-size: 10px; text-align: right;}";
      style =
        style + ".bigger-mini-font-left {font-size: 11px; text-align: left;}";
      style = style + ".sub-table {width : 98%}";
      style = style + ".sub-table-no-border td{border: none}";
      style =
        style +
        ".english-text {color: #696969; padding-top: -2em; font-size: 9px}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      // var win = window.open('', '', 'height=700,width=700');
      let win = window.open("", "");

      win.document.write("<html><head>");
      win.document.write("<title>ใบรายการชำระเงินค่าธรรมเนียม สจล.</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      // win.close(); // CLOSE THE CURRENT WINDOW.

      setTimeout(function () {
        win.print();
      }, 100); // PRINT THE CONTENTS.
    },
    // English Text money
    inWords(num) {
      if ((num = num.toString()).length > 9) return "overflow";
      let n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      let str = "";
      str +=
        n[1] != 0
          ? (this.a[Number(n[1])] || this.b[n[1][0]] + " " + this.a[n[1][1]]) +
            "million "
          : "";
      str +=
        n[2] != 0
          ? (this.a[Number(n[2])] || this.b[n[2][0]] + " " + this.a[n[2][1]]) +
            "hundred "
          : "";
      str +=
        n[3] != 0
          ? (this.a[Number(n[3])] || this.b[n[3][0]] + " " + this.a[n[3][1]]) +
            "thousand "
          : "";
      str +=
        n[4] != 0
          ? (this.a[Number(n[4])] || this.b[n[4][0]] + " " + this.a[n[4][1]]) +
            "hundred "
          : "";
      str +=
        n[5] != 0
          ? (str != "" ? "and " : "") +
            (this.a[Number(n[5])] || this.b[n[5][0]] + " " + this.a[n[5][1]]) +
            ""
          : "";
      return str;
    },
    withDecimal(n) {
      let nums = n.toString().split(".");
      let whole = this.inWords(nums[0]);
      if (nums[1] > 1) {
        let fraction = this.inWords(nums[1]);
        return whole + "point " + fraction + "baht";
      } else {
        return whole + "baht";
      }
    },
    // Thai text money
    getText(input) {
      let toNumber = input.toString();
      let numbers = toNumber.split("").reverse();

      let numberText = "/หนึ่ง/สอง/สาม/สี่/ห้า/หก/เจ็ด/แปด/เก้า/สิบ".split("/");
      let unitText = "/สิบ/ร้อย/พัน/หมื่น/แสน/ล้าน".split("/");

      let output = "";
      for (let i = 0; i < numbers.length; i++) {
        let number = parseInt(numbers[i]);
        let text = numberText[number];
        let unit = unitText[i];
        if (number == 0) continue;
        if (i == 1 && number == 2) {
          output = "ยี่สิบ" + output;
          continue;
        }
        if (i == 1 && number == 1) {
          output = "สิบ" + output;
          continue;
        }
        output = text + unit + output;
      }
      return output;
    },
    getBahtText(inputNumber) {
      let fullNumber = Math.floor(inputNumber);
      let decimal = inputNumber - fullNumber;

      if (decimal == 0) {
        return this.getText(fullNumber) + "บาทถ้วน";
      } else {
        // convert decimal into full number, need only 2 digits
        decimal = decimal * 100;
        decimal = Math.round(decimal);

        return (
          this.getText(fullNumber) + "บาท" + this.getText(decimal) + "สตางค์"
        );
      }
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.svg-container {
  width: 80%;
}
body {
  width: 90%;
  margin: auto;
  font-family: "Sarabun", sans-serif;
  font-size: 14px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
u {
  text-decoration: underline;
}
/* p {
            border-bottom: solid white 1px;
        } */
.span1 {
  color: red;
  margin-left: 2rem;
  margin-top: 80rem;
}

/* table */
table,
th,
td,
tr {
  table-layout: fixed;
  overflow: hidden;
  border: 0px;
}
table.center {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.cell {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  border-top: double;
  border-top-width: 4px;
  font-size: 13px;
}
.cell th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
}
.cell td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
}

.cell-total {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.cell-total th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
  font-size: 13px;
}
.cell-total td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
  font-size: 13px;
}

.notice-box {
  padding: 10px 10px 10px 10px;
  outline-style: solid;
  outline-color: silver;
  outline-width: 1px;
  outline-offset: -10px;
  text-align: left;
}

.notice-box1 {
  text-align: center;
  color: red;
}

.tab1 {
  padding-left: 0.2em;
  text-indent: 2em;
  /* font-size: 10px; */
}

.mini-font-left {
  font-size: 8px;
  text-align: left;
}

.mini-font {
  font-size: 8px;
  text-align: center;
}

.seperate-page {
  font-size: 11px;
  text-align: center;
}

.bigger-mini-font-right {
  font-size: 11px;
  text-align: right;
}
.bigger-mini-font-left {
  font-size: 11px;
  text-align: left;
}

.sub-table {
  width: 95%;
}

.sub-table-no-border td {
  border: none;
}

.english-text {
  color: #696969;
  padding-top: -2em;
}

.button {
  border-radius: 36px;
  background-color: #ff5722;
  border: none;
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  padding: 15px;
  width: 100%;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);
}
.button:hover {
  background-color: #963112;
}
.button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.3s;
}
.button span:after {
  content: "<< CLICK >>";
  font-size: 16px;
  position: relative;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.3s;
}
.button:hover span {
  padding-right: 100px;
}
.button:hover span:after {
  opacity: 1;
  right: 0;
}
.payment-card {
  /* width: 750px; */
  padding-top: 25px;
  padding-bottom: 25px;
  max-width: 850px;
}
</style>
